import {FC} from 'react'

const MetricCardSkeleton: FC = () => (
  <div className='card shadow-sm metric-card organizations-overview-skeleton__metric-card'>
    <div className='card-body d-flex flex-column metric-card__body'>
      <div className='d-flex flex-column metric-card__header'>
        <div className='organizations-overview-skeleton__title placeholder-wave' />
        <div className='d-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-baseline gap-5'>
            <div className='organizations-overview-skeleton__value placeholder-wave' />
            <div className='organizations-overview-skeleton__period placeholder-wave' />
          </div>
          <div className='organizations-overview-skeleton__trend placeholder-wave' />
        </div>
      </div>
      <div className='d-flex flex-column metric-card__breakout-container'>
        <div className='organizations-overview-skeleton__breakout-title placeholder-wave' />
        <div className='organizations-overview-skeleton__chart placeholder-wave' />
      </div>
    </div>
  </div>
)

const ShipmentTrendsSkeleton: FC = () => (
  <div className='card shadow-sm shipment-trends organizations-overview-skeleton__trends'>
    <div className='card-body shipment-trends__body'>
      <div className='shipment-trends__header'>
        <div className='organizations-overview-skeleton__trends-title placeholder-wave' />
        <div className='shipment-trends__controls'>
          <div className='organizations-overview-skeleton__trends-segment placeholder-wave' />
          <div className='organizations-overview-skeleton__trends-expand placeholder-wave' />
        </div>
      </div>
      <div className='organizations-overview-skeleton__trends-chart placeholder-wave' />
    </div>
  </div>
)

const OrganizationOverviewSkeleton: FC = () => (
  <>
    <div className='organizations-overview__shipment-metrics col-12'>
      <div className='organizations-overview__metrics-wrapper'>
        <MetricCardSkeleton />
      </div>
      <div className='organizations-overview__metrics-wrapper'>
        <MetricCardSkeleton />
      </div>
    </div>
    <div className='col-12'>
      <ShipmentTrendsSkeleton />
    </div>
  </>
)

export {OrganizationOverviewSkeleton, ShipmentTrendsSkeleton}
